<template>
    <v-container fluid>
        <v-row style="top: 60px; position: fixed; z-index:10; background-color: #f8f8f8; padding-top:4px; margin-left: -30px; width:100%" v-if="!apiLoading">
            <v-col cols="12" style="display:flex" float="left">
                <h2 style="font-weight: 500 !important">{{title}}</h2>
                <v-btn class="ml-4" v-if="!editMode" color="primary" text @click="enableEditMode">
                    <v-icon small class="mx-1">settings</v-icon>
                    {{$t('wkt.admin.dashboards.menu.edit')}}
                </v-btn>
                <v-btn class="ml-4" v-if="editMode" color="primary" text @click="showSelectWidgetDialog=true">
                    <v-icon small class="mx-1">add</v-icon>
                    {{$t('wkt.admin.dashboards.menu.add')}}
                </v-btn>
                <v-btn v-if="editMode" color="primary" text @click="confirmEditMode">
                    <v-icon small class="mx-1">done</v-icon>
                    {{$t('wkt.admin.dashboards.menu.save')}}
                </v-btn>
                <v-btn v-if="editMode" color="primary" text @click="cancelEditMode">
                    <v-icon small class="mx-1">close</v-icon>
                    {{$t('wkt.admin.dashboards.menu.cancel')}}
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="apiLoading">
            <v-col cols="12" >
                <v-skeleton-loader
                type="table-tbody"
                ></v-skeleton-loader>
            </v-col>
        </v-row>
        
        <v-row style="padding-top:0; margin-top: -24px;" v-if="!apiLoading">
            <v-col cols="6" v-for="(item, index) in items" :key="item.id">
                <WidgetWrapper :editMode="editMode" :enableLeft="(index>0)" :enableRight="(index<items.length-1)" 
                    ref="widgetRefs" :config="item" :context="context" v-on:edit-action="(action) => onEditAction(item, index, action)"/>
            </v-col>
            <v-col cols="12" v-if="!this.items || this.items.length==0 ">
                <div class="transparent empty-state center-align">
                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                        <div class="text-center">
                            <i class="large material-icons" style="cursor: pointer;">widgets</i>
                            <h4>{{ $t('wkt.admin.dashboards.main.empty-title') }}</h4>
                            <p>{{ $t('wkt.admin.dashboards.main.empty-subtitle') }}</p>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        
        <SelectWidgetDialog :showDialog="showSelectWidgetDialog" :currentLicense="currentLicense" :widgets="allWidgets" v-on:select-widget="selectWidget"></SelectWidgetDialog>
   
   
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
                </v-btn>
            </v-snackbar>
   </v-container>
</template>

<script> 

import WidgetWrapper from "./dashboard/WidgetWrapper";
import SelectWidgetDialog from "./dashboard/SelectWidgetDialog"
import BaseModule from '../common/BaseModule.js'
import api from '../../api/worktime';
import gwt from '../../api/gwt';

export default {
  name: 'DashboardModule',
  mixins: [BaseModule],
  components: { 
    WidgetWrapper, SelectWidgetDialog
  },
  
  data() {
      return {  title: 'Dashboard',
                showSelectWidgetDialog:false,
                moduleId:'staff',
                userConfig:{},
                items: [],
                context: {},
                allWidgets: [],
                maxWidgets: 4,
                apiLoading: true,
                widgetLoading: false,
				errorMessage: null,
                currentLicense: 0,
				showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000,
                editMode: false,
                itemsStash:[]
      }
  },
   methods: {
    getWidgets() {
				if(this.widgetLoading) {
                    return;
                }
				this.apiLoading = true;
                this.widgetLoading = true;
				api.getWidgets(
                    data => {
                            this.widgetLoading = false;
                            this.allWidgets = data;
                            this.loadUserConfig();
                    }, err => {
                            //this.isLoading = false;
                            this.widgetLoading = false;
                            this.apiLoading = false;
                            console.log(err);
                            this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                    });
		},
    onReveal(payload) {

        let profile = gwt.getSessionProfile();

        if (!profile) { //todavía no se ha inicializado la aplicación
            return;
        }

        let sessionInformation = gwt.getSessionInformation();
        this.currentLicense = sessionInformation && sessionInformation.company && sessionInformation.company.licensePlan>0 ?1:0;
        this.editMode=false;

        this.maxWidgets = 4; // FREE
        if (this.currentLicense==1) {
            this.maxWidgets = 6; //Business
        } else if (this.currentLicense==2) { 
            this.maxWidgets = 8; //Corporate
        }

        this.title = payload.title?payload.title:'Dashboard';
        
        if (this.mustRefresh() || !this.allWidgets || this.allWidgets.length==0) { // Primer acceso
            this.moduleId=payload.moduleId;
            this.getWidgets();
        } else if (this.moduleId!=payload.moduleId) { // hemos cambiado de módulo
            this.moduleId=payload.moduleId;
            this.applyConfig();
        } else {
            this.context=payload; // se han actualizado los filtros globales
        }
        
    },
    enableEditMode() {
        this.editMode=true;
        this.itemsStash=[...this.items];
    },
    confirmEditMode() {
        this.editMode=false;
        this.itemsStash=[];
        let dbConfig = this.userConfig[this.moduleId];
        dbConfig.widgetList = [] 
        for (let w of this.items) {
            dbConfig.widgetList.push(w.id);
        }
        this.presistUserConfig();
    },
    cancelEditMode() {
        this.editMode=false;
        this.items=this.itemsStash;
        this.itemsStash=[];
    },
    applyConfig() {

        let profile = gwt.getSessionProfile();
        let sessionInformation = gwt.getSessionInformation();
        let isSuperAdmin = sessionInformation?sessionInformation.employee.isSuperAdmin:false;
    
        //revisamos permisos
        for (let item of this.allWidgets) {
            item.isAllowed = isSuperAdmin || !item.rolesAllowed || this.matchRole(profile,item.rolesAllowed.split(','));
        }

        //configuración de usuario
        if (!this.userConfig[this.moduleId]) {
            this.userConfig[this.moduleId]={};
        }

        let dbConfig = this.userConfig[this.moduleId];

        //Configuración por defecto
        if (!dbConfig.widgetList) {
            dbConfig.widgetList = [];
            for (let w of this.allWidgets) {
               if (w.modulesDefault && w.modulesDefault.indexOf(this.moduleId)>=0) {
                dbConfig.widgetList.push(w.id);
               }
            }
            //this.presistUserConfig();
        }

        //Mostramos widgets seleccionados
        let selectedWidgets=[];
        dbConfig.widgetList.map(wid=> {
            let widget = this.getWidgetById(wid);
            if (widget && widget.isAllowed && this.currentLicense>=widget.license) {
                selectedWidgets.push(widget)
            }
        })
        selectedWidgets = selectedWidgets.slice(0, this.maxWidgets);
        this.items = selectedWidgets;
    },
    matchRole(profile,roles) {
        
        for (let role of roles) {
            let permissionName = 'module'+role;
            let permissionValue = -1;
            for (const [key] of Object.entries(profile)) {
                if (key.toLowerCase()===permissionName.toLocaleLowerCase()) {
                    permissionValue = profile[key];
                    break;
                }
            }

            if (permissionValue===1 || permissionValue===2) {
                return true;
            }
        }

        return false;
    },
    getWidgetById(id) {
        for (let w of this.allWidgets) {
               if (w.id == id) {
                return w;
               } 
        }
        return null;
    },
    onEditAction(widget, index, action) { 
        if (action==0) {
            this.items.splice(index, 1);
            return;
        }
        this.arrayMove(this.items, index, index+action);
    },
    selectWidget(widget) {

        if (widget && this.items.includes(widget)) {
            this.doShowAlert({ text: this.$t('wkt.admin.dashboards.main.add.existing-error'), color: 'warning', timeout: 3000 });
            return;
        }

        if (widget && this.items.length >= this.maxWidgets) {
            this.doShowAlert({ text: this.$t('wkt.admin.dashboards.main.limit-error'), color: 'error', timeout: 3000 });
            return;
        }

        if (widget) {
            this.items.unshift(widget);
        }
        this.showSelectWidgetDialog=false;
    },
    arrayMove(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    },
    loadUserConfig() {
     
     api.getDataBag('admin.dashboard.config',
               data => {
                   this.userConfig=data?JSON.parse(data.value):{};
                   this.applyConfig();
                   this.apiLoading = false;
               },
               err => {
                   console.log(err);
                   this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                   this.apiLoading = false;
               });	

   },
   presistUserConfig() {
     
       let db = { 'key':'admin.dashboard.config',
                   'value':JSON.stringify(this.userConfig)}
       api.storeDataBag(db,
               res => {
                   console.log(res);
               },
               err => {
                   console.log(err);
                   this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
               });	

   },
   doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
   }
};
</script>
